// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class EnterpriseCoordinatorSiteServiceModelsSiteUpsearchModel {
    static getAttributeTypeMap() {
        return EnterpriseCoordinatorSiteServiceModelsSiteUpsearchModel.attributeTypeMap;
    }
}
EnterpriseCoordinatorSiteServiceModelsSiteUpsearchModel.discriminator = undefined;
EnterpriseCoordinatorSiteServiceModelsSiteUpsearchModel.attributeTypeMap = [
    {
        "name": "accountRelationshipIsPrimary",
        "baseName": "accountRelationshipIsPrimary",
        "type": "boolean"
    },
    {
        "name": "pointOfContacts",
        "baseName": "pointOfContacts",
        "type": "Array<EnterpriseCoordinatorSiteServiceModelsSitePointOfContactUpsearchModel>"
    },
    {
        "name": "siteId",
        "baseName": "siteId",
        "type": "number"
    },
    {
        "name": "siteRoleType",
        "baseName": "siteRoleType",
        "type": "RoleType"
    },
    {
        "name": "description",
        "baseName": "description",
        "type": "string"
    },
    {
        "name": "nickName",
        "baseName": "nickName",
        "type": "string"
    },
    {
        "name": "businessStartTime",
        "baseName": "businessStartTime",
        "type": "Date"
    },
    {
        "name": "businessEndTime",
        "baseName": "businessEndTime",
        "type": "Date"
    },
    {
        "name": "addresses",
        "baseName": "addresses",
        "type": "Array<EnterpriseCoordinatorSharedAddressUpsearchModel>"
    },
    {
        "name": "contacts",
        "baseName": "contacts",
        "type": "Array<EnterpriseCoordinatorSharedContactUpsearchModel>"
    },
    {
        "name": "emailAddresses",
        "baseName": "emailAddresses",
        "type": "Array<EnterpriseCoordinatorSharedEmailAddressUpsearchModel>"
    },
    {
        "name": "externalIds",
        "baseName": "externalIds",
        "type": "Array<EnterpriseCoordinatorSharedExternalIdUpsearchModel>"
    },
    {
        "name": "phoneNumbers",
        "baseName": "phoneNumbers",
        "type": "Array<EnterpriseCoordinatorSharedPhoneUpsearchModel>"
    },
    {
        "name": "globalIds",
        "baseName": "globalIds",
        "type": "Array<EnterpriseCoordinatorSharedGlobalIdUpsearchModel>"
    }
];
//# sourceMappingURL=enterpriseCoordinatorSiteServiceModelsSiteUpsearchModel.js.map